module.exports = __webpack_public_path__ + "static/media/grade10.497b21fc.jpg";